import React from "react";
import CustomEditor from "../common/Editor";

export default function ExplanationField({
  valueFa,
  valueEn,
  onChangeFa,
  onChangeEn,
  isRtl,
}) {
  return (
    <div className="mt-5">
      <h3 className="text-sm font-semibold mb-2">توضیح / Explanation</h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div dir={isRtl ? "rtl" : "ltr"}>
          <label className="block text-xs font-medium mb-1">توضیح (FA)</label>
          <CustomEditor
            value={valueFa}
            onEditorChange={onChangeFa}
            placeholder="توضیح فارسی..."
            directionality={isRtl ? "rtl" : "ltr"}
          />
        </div>

        <div dir="ltr">
          <label className="block text-xs font-medium mb-1">Explanation (EN)</label>
          <CustomEditor
            value={valueEn}
            onEditorChange={onChangeEn}
            placeholder="Explanation in English..."
          />
        </div>
      </div>
    </div>
  );
}
